// 3rd party
import React from "react";
import { FormattedMessage, useIntl, defineMessages } from "react-intl";
import { Grid } from "@material-ui/core";

// components
import { Card } from "../common/card/card";
import { Header } from "../common/title/header";
import { useWorkOrderStyles, Caption, Value, CardTitle } from "./workOrderDetails";

import { WORKTYPES } from "../../globals/workTypes";

// helper functions
import { useLocalizedName } from "../../globals/langHelpers";

const messages = defineMessages({
    yesResponse: {
        id: "admin.work-order-info.job-description.yes-response",
        defaultMessage: "Yes",
        description: "response to question",
    },
    noResponse: {
        id: "admin.work-order-info.job-description.no-response",
        defaultMessage: "No",
        description: "response to question",
    },
});
const WorkOrderJobDescriptionInfo = ({ relatedIdInformation }) => {
    const classes = useWorkOrderStyles();
    const intl = useIntl();
    const { getLocalizedName } = useLocalizedName();

    if (!relatedIdInformation?.tasks?.workType) {
        return null;
    }
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} className={classes.noBottomPadding}>
                <Header>
                    <FormattedMessage
                        id="admin.work-order-details.wo-info.job-description-title"
                        defaultMessage="Job description"
                        description="Admin work order Job description title"
                    />
                </Header>
            </Grid>
            <Grid item xs={12}>
                <Card>
                    <CardTitle>
                        <FormattedMessage
                            id="admin.work-order-details.wo-info.work-details-title"
                            defaultMessage="Work details"
                            description="Admin work order work details title"
                        />
                    </CardTitle>
                    <Grid container className={classes.row}>
                        <Grid item xs={3}>
                            <Caption>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.parent-job-classifcation-caption"
                                    defaultMessage="Parent job classifcation"
                                    description="Admin work order Parent job classifcation caption"
                                />
                            </Caption>
                            <Value>{getLocalizedName({ object: relatedIdInformation?.jobClassification })}</Value>
                        </Grid>
                        <Grid item xs={3}>
                            <Caption>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.priority-caption"
                                    defaultMessage="Priority"
                                    description="Admin work order Priority caption"
                                />
                            </Caption>
                            <Value>{getLocalizedName({ object: relatedIdInformation?.tasks?.priority })?.split(" ")[0]}</Value>
                        </Grid>
                        <Grid item xs={3}>
                            <Caption>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.wo-reason-caption"
                                    defaultMessage="Reason for work order"
                                    description="Admin work order Reason for work order caption"
                                />
                            </Caption>
                            <Value>{getLocalizedName({ object: relatedIdInformation?.workOrderReason })}</Value>
                        </Grid>
                    </Grid>

                    {relatedIdInformation?.tasks?.workType?.id === WORKTYPES?.MH_WORK && (
                        <>
                            <Grid container className={classes.row}>
                                <Grid item xs={3}>
                                    <Caption style={{ paddingRight: "2px" }}>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.cs-entry-num-caption"
                                            defaultMessage="CS entry number"
                                            description="Admin work order CS entry number caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.confinedSpaceNumber}</Value>
                                </Grid>
                                <Grid item xs={3}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.manhole-route-caption"
                                            defaultMessage="Manhole route"
                                            description="Admin work order manhole route caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.manHoleIdentifierRoute}</Value>
                                </Grid>
                                <Grid item xs={3}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.cs-number-caption"
                                            defaultMessage="CS number"
                                            description="Admin work order CS number caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.manHoleIdentifierId}</Value>
                                </Grid>
                                <Grid item xs={3}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.cs-type-caption"
                                            defaultMessage="CS type"
                                            description="Admin work order CS type caption"
                                        />
                                    </Caption>
                                    <Value>{getLocalizedName({ object: relatedIdInformation?.csType })}</Value>
                                </Grid>
                            </Grid>
                            <Grid container className={classes.row}>
                                <Grid item xs={3}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.street-name-caption"
                                            defaultMessage="Street"
                                            description="Admin work order street caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation?.streetName}</Value>
                                </Grid>
                                <Grid item xs={3}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.cross-street-caption"
                                            defaultMessage="Cross street"
                                            description="Admin work order cross street caption"
                                        />
                                    </Caption>
                                    <Value>{relatedIdInformation.crossStreet}</Value>
                                </Grid>
                                <Grid item xs={2}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.manhole-contaminated-caption"
                                            defaultMessage="Manhole contaminated"
                                            description="Admin work order manhole contaminated caption"
                                        />
                                    </Caption>
                                    <Value>
                                        {relatedIdInformation.manholeContaminated
                                            ? intl.formatMessage(messages.yesResponse)
                                            : intl.formatMessage(messages.noResponse)}
                                    </Value>
                                </Grid>
                            </Grid>
                        </>
                    )}

                    {relatedIdInformation?.tasks?.workType?.id === WORKTYPES?.MISCELLANEOUS && <Grid container className={classes.row}></Grid>}
                    {(relatedIdInformation?.tasks?.workType?.id === WORKTYPES.AERIAL_WORK ||
                        relatedIdInformation?.tasks?.workType?.id === WORKTYPES?.BURIED_WORK) && (
                        <Grid container className={classes.row}>
                            <Grid item xs={3}>
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.wo-info.network-type-caption"
                                        defaultMessage="Network type"
                                        description="Admin work order Network type caption"
                                    />
                                </Caption>
                                <Value>{relatedIdInformation?.networkType}</Value>
                            </Grid>
                            <Grid item xs={3}>
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.wo-info.plant-type-caption"
                                        defaultMessage="Plant type"
                                        description="Admin work order Plant type caption"
                                    />
                                </Caption>
                                <Value>{getLocalizedName({ object: relatedIdInformation?.plantTypeDetails })}</Value>
                            </Grid>
                        </Grid>
                    )}
                </Card>
            </Grid>
        </Grid>
    );
};

export default WorkOrderJobDescriptionInfo;
